<template>
  <div class="finish">
    <div class="icon">
      <CheckIcon />
    </div>
    <h1>Data úspěšně odeslána</h1>
    <div class="btns-bottom">
      <div class="container">
        <div class="box btns">
          <button type="button" class="secondary" v-on:click="goHome">
            Přidat další
          </button>
          <button type="button" v-on:click="goHistory()">Hotovo</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import CheckIcon from "@/icons/CheckIcon.vue";
import sendMessage from "../utils/functions";
import store from "../store";

export default {
  name: "Finish",
  mounted() {
    document.title = "GPS Dozor Servis";
    if (store.state.role == 2) {
      this.$router.push("history");
      return;
    }
  },
  components: {
    CheckIcon
  },
  computed: {},
  data: function() {
    return {};
  },
  methods: {
    goHome: function() {
      sendMessage(`state:finished`);
      this.$router.push("/");
    },
    goHistory: function() {
      sendMessage(`state:finished`);
      this.$router.push("/history");
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/1-base/variables";

h1 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 24px;
}

.icon {
  margin-bottom: 60px;
  color: @green;
  svg {
    display: block;
    margin: 0 auto;
    width: 100px;
  }
}

.box {
  padding-top: 14px;
  padding-bottom: 14px;

  button {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  &.btns {
    display: flex;
    align-items: center;
    border-bottom: 0;

    button {
      margin-top: 0;
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}

.btns-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  .container {
    max-width: 100%;
    width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    background: @white-common;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  button {
    font-size: 14px;
  }
}
</style>
